/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Taginteractive1Inputs */

const zh_showcase_taginteractive1 = /** @type {(inputs: Showcase_Taginteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`互动教学`)
};

const en_showcase_taginteractive1 = /** @type {(inputs: Showcase_Taginteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive`)
};

const es_showcase_taginteractive1 = /** @type {(inputs: Showcase_Taginteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactivo`)
};

/**
* | output |
* | --- |
* | "Interactive" |
*
* @param {Showcase_Taginteractive1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_taginteractive1 = /** @type {((inputs?: Showcase_Taginteractive1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Taginteractive1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_taginteractive1(inputs)
	if (locale === "en") return en_showcase_taginteractive1(inputs)
	return es_showcase_taginteractive1(inputs)
});
export { showcase_taginteractive1 as "showcase_tagInteractive" }